import { render, staticRenderFns } from "./text.vue?vue&type=template&id=758576cc&scoped=true&"
import script from "./textControl.js?vue&type=script&lang=js&"
export * from "./textControl.js?vue&type=script&lang=js&"
import style0 from "./text.vue?vue&type=style&index=0&id=758576cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758576cc",
  null
  
)

export default component.exports